module.exports = __webpack_public_path__ + "img/sTriKfMnky_350x350.4490462a.jpg";